module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_8017.7b70243f.png";